 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Popup":"Popup","changepassword":"changepassword","featuredCarousel":"featuredCarousel","sliderCarousel":"sliderCarousel","configClass":"configClass","editProfile":"editProfile","facebook popup":"facebook popup","failed popup":"failed popup","plans":"plans","popupLogin":"popupLogin","purchased":"purchased","settings":"settings","success popup":"success popup","appLoader":"appLoader","intermidiate popup":"intermidiate popup","payment Popup":"payment Popup","quality Popup":"quality Popup","Header":"Header","hlsjs":"hlsjs","featuredPlaceholder":"featuredPlaceholder","shaka":"shaka","contentCard":"contentCard","Placeholder":"Placeholder","listContents":"listContents","ContentDescription":"ContentDescription","contentslider":"contentslider","dislike button":"dislike button","likebutton":"likebutton","share":"share","popupAbout":"popupAbout","popupHelp":"popupHelp","popupPrivacy":"popupPrivacy","popupTandC":"popupTandC","vLiveWebSdk":"vLiveWebSdk","userClass":"userClass","date-picker":"date-picker","formError":"formError","wallet":"wallet","HeaderMenu":"HeaderMenu","headerRight":"headerRight","placeHolder":"placeHolder","sliderCarousal":"sliderCarousal","facebook-svg":"facebook-svg","twitter-svg":"twitter-svg","dropdown":"dropdown","mobilePopup":"mobilePopup","selectPopup":"selectPopup","search":"search","userModule":"userModule","notification":"notification","popupResetPassword":"popupResetPassword","popupSignup":"popupSignup","profileMenu":"profileMenu","logoutIconVlite":"logoutIconVlite"}[chunkId]||chunkId) + "." + {"Popup":"5fed7508","changepassword":"dd1d7cac","chunk-005dbee5":"647a58c7","chunk-06f93556":"ea4972eb","chunk-08733ace":"77da5425","chunk-0d0c5399":"e8a05314","chunk-1b55fe96":"5358435a","chunk-1f4ba480":"bb2d39a4","chunk-2610ba1c":"f11d22a0","chunk-28c291c7":"af336457","chunk-2d0d097b":"194cc019","chunk-2d0d5f85":"e497dc8a","chunk-4f0fa7d6":"e90dc64f","featuredCarousel":"d665e737","chunk-2d212fd5":"d5dcd007","chunk-2d825f5e":"9f7c1993","chunk-2f4ba676":"ff649bcb","chunk-353e4619":"cadd3cbd","chunk-36fb365b":"860f832d","chunk-1adda8d8":"0b6549e7","sliderCarousel":"ce4466f5","chunk-367353c2":"91ef91fe","chunk-4fef615e":"cb838a85","chunk-50cc0513":"df0cd81d","chunk-39e134d5":"7e0a81f6","chunk-7793abb4":"6270b70a","chunk-54d24eb4":"18654597","chunk-54da03cf":"a65ebed6","chunk-5f00bf0d":"5df32c3b","chunk-700b0560":"cf38e5dd","chunk-74f991af":"28917c8d","chunk-7f396950":"e760fc42","chunk-b958f4a2":"d934f57c","chunk-dfd8a6ce":"22668262","chunk-ec7605fa":"cd6727e9","chunk-f7e3761a":"b52a8255","configClass":"6766d9ce","editProfile":"47a2219b","facebook popup":"1622b4d3","failed popup":"cb8bcaaa","plans":"1f48358d","popupLogin":"1f7147b5","purchased":"d6bd927a","settings":"f0d29d7b","success popup":"97cc41f6","appLoader":"cdea0e4a","intermidiate popup":"b7bc39f0","payment Popup":"f2eee8a8","quality Popup":"26bfac92","Header":"10c0f866","hlsjs":"16c9589d","featuredPlaceholder":"37f8c93a","shaka":"963f8428","contentCard":"69f5a0f7","Placeholder":"3f385706","listContents":"664cd76a","ContentDescription":"82360f7c","chunk-1b53e675":"2c45ffc9","contentslider":"e025a52d","dislike button":"ee3f9551","likebutton":"0399a337","share":"8ac17403","chunk-0037ca14":"3b870e58","chunk-053d3247":"4cb588e9","chunk-0afaa40e":"60cdbb58","chunk-58a09b2a":"2725018f","popupAbout":"49cca638","popupHelp":"f4f0114e","popupPrivacy":"cafcc340","popupTandC":"e4702ff2","vLiveWebSdk":"99ab011e","userClass":"57bc83d5","date-picker":"2d631f17","chunk-b7345778":"0b4a0ac4","formError":"763c5512","wallet":"ce89c790","HeaderMenu":"443eded6","headerRight":"61220f50","placeHolder":"9003faf2","sliderCarousal":"4df6abb1","facebook-svg":"a154563f","twitter-svg":"6a723557","dropdown":"31bb8c40","mobilePopup":"4843fd5c","selectPopup":"2f3a46ee","search":"f612b95b","userModule":"228bc612","chunk-4673eeb4":"c327daac","chunk-327e7090":"52af8301","notification":"b877fc41","popupResetPassword":"2d596ac0","popupSignup":"8d87a7af","profileMenu":"b45fcd18","chunk-2d21ecf9":"91de2e41","logoutIconVlite":"c4b39326"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Popup":1,"changepassword":1,"chunk-005dbee5":1,"chunk-06f93556":1,"chunk-08733ace":1,"chunk-1b55fe96":1,"chunk-1f4ba480":1,"chunk-2610ba1c":1,"chunk-28c291c7":1,"chunk-4f0fa7d6":1,"featuredCarousel":1,"chunk-2d825f5e":1,"chunk-2f4ba676":1,"chunk-1adda8d8":1,"sliderCarousel":1,"chunk-367353c2":1,"chunk-4fef615e":1,"chunk-50cc0513":1,"chunk-54d24eb4":1,"chunk-5f00bf0d":1,"chunk-700b0560":1,"chunk-b958f4a2":1,"chunk-ec7605fa":1,"editProfile":1,"facebook popup":1,"failed popup":1,"plans":1,"popupLogin":1,"purchased":1,"settings":1,"success popup":1,"appLoader":1,"intermidiate popup":1,"payment Popup":1,"quality Popup":1,"Header":1,"featuredPlaceholder":1,"contentCard":1,"Placeholder":1,"listContents":1,"ContentDescription":1,"chunk-1b53e675":1,"contentslider":1,"dislike button":1,"likebutton":1,"share":1,"chunk-0037ca14":1,"chunk-053d3247":1,"chunk-0afaa40e":1,"chunk-58a09b2a":1,"popupAbout":1,"popupHelp":1,"popupPrivacy":1,"popupTandC":1,"chunk-b7345778":1,"formError":1,"wallet":1,"HeaderMenu":1,"headerRight":1,"placeHolder":1,"sliderCarousal":1,"facebook-svg":1,"twitter-svg":1,"dropdown":1,"mobilePopup":1,"selectPopup":1,"search":1,"userModule":1,"chunk-4673eeb4":1,"chunk-327e7090":1,"notification":1,"popupResetPassword":1,"popupSignup":1,"profileMenu":1,"logoutIconVlite":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Popup":"Popup","changepassword":"changepassword","featuredCarousel":"featuredCarousel","sliderCarousel":"sliderCarousel","configClass":"configClass","editProfile":"editProfile","facebook popup":"facebook popup","failed popup":"failed popup","plans":"plans","popupLogin":"popupLogin","purchased":"purchased","settings":"settings","success popup":"success popup","appLoader":"appLoader","intermidiate popup":"intermidiate popup","payment Popup":"payment Popup","quality Popup":"quality Popup","Header":"Header","hlsjs":"hlsjs","featuredPlaceholder":"featuredPlaceholder","shaka":"shaka","contentCard":"contentCard","Placeholder":"Placeholder","listContents":"listContents","ContentDescription":"ContentDescription","contentslider":"contentslider","dislike button":"dislike button","likebutton":"likebutton","share":"share","popupAbout":"popupAbout","popupHelp":"popupHelp","popupPrivacy":"popupPrivacy","popupTandC":"popupTandC","vLiveWebSdk":"vLiveWebSdk","userClass":"userClass","date-picker":"date-picker","formError":"formError","wallet":"wallet","HeaderMenu":"HeaderMenu","headerRight":"headerRight","placeHolder":"placeHolder","sliderCarousal":"sliderCarousal","facebook-svg":"facebook-svg","twitter-svg":"twitter-svg","dropdown":"dropdown","mobilePopup":"mobilePopup","selectPopup":"selectPopup","search":"search","userModule":"userModule","notification":"notification","popupResetPassword":"popupResetPassword","popupSignup":"popupSignup","profileMenu":"profileMenu","logoutIconVlite":"logoutIconVlite"}[chunkId]||chunkId) + "." + {"Popup":"d323afb1","changepassword":"6f5ec444","chunk-005dbee5":"59a84d28","chunk-06f93556":"fd7a1ac9","chunk-08733ace":"a4a8b50f","chunk-0d0c5399":"31d6cfe0","chunk-1b55fe96":"0f387ab3","chunk-1f4ba480":"5b1d9f24","chunk-2610ba1c":"ae56f9c5","chunk-28c291c7":"c611cc70","chunk-2d0d097b":"31d6cfe0","chunk-2d0d5f85":"31d6cfe0","chunk-4f0fa7d6":"4a0a516f","featuredCarousel":"4cd9b384","chunk-2d212fd5":"31d6cfe0","chunk-2d825f5e":"c46fb23e","chunk-2f4ba676":"882e4a30","chunk-353e4619":"31d6cfe0","chunk-36fb365b":"31d6cfe0","chunk-1adda8d8":"739d8447","sliderCarousel":"c3f0668b","chunk-367353c2":"993c69be","chunk-4fef615e":"8b55bafc","chunk-50cc0513":"7eecc998","chunk-39e134d5":"31d6cfe0","chunk-7793abb4":"31d6cfe0","chunk-54d24eb4":"829aa68a","chunk-54da03cf":"31d6cfe0","chunk-5f00bf0d":"a43b0b1a","chunk-700b0560":"6041916d","chunk-74f991af":"31d6cfe0","chunk-7f396950":"31d6cfe0","chunk-b958f4a2":"380242dd","chunk-dfd8a6ce":"31d6cfe0","chunk-ec7605fa":"dc770bec","chunk-f7e3761a":"31d6cfe0","configClass":"31d6cfe0","editProfile":"a8b6f80b","facebook popup":"8d8522f9","failed popup":"8b1be6e6","plans":"0abd16c1","popupLogin":"4574075c","purchased":"ecf019ea","settings":"747ab315","success popup":"9616b541","appLoader":"8660bd98","intermidiate popup":"b0aae32f","payment Popup":"3df0bc49","quality Popup":"3446b39a","Header":"b1f93698","hlsjs":"31d6cfe0","featuredPlaceholder":"8c698aa7","shaka":"31d6cfe0","contentCard":"a9ca5b3b","Placeholder":"011030dc","listContents":"6df1be0a","ContentDescription":"c6e88f4b","chunk-1b53e675":"8c63eca4","contentslider":"be6d5015","dislike button":"28fab7c0","likebutton":"ec5a6fb0","share":"a40070c1","chunk-0037ca14":"5e7fb5ec","chunk-053d3247":"e63a5bb2","chunk-0afaa40e":"6adec496","chunk-58a09b2a":"e70d3791","popupAbout":"d9ee5330","popupHelp":"0162d727","popupPrivacy":"b7fa1bf8","popupTandC":"50873bad","vLiveWebSdk":"31d6cfe0","userClass":"31d6cfe0","date-picker":"31d6cfe0","chunk-b7345778":"76987ed0","formError":"b629469e","wallet":"1a288f5d","HeaderMenu":"f89326a9","headerRight":"5ea9cea7","placeHolder":"893243d0","sliderCarousal":"63c97934","facebook-svg":"3122e211","twitter-svg":"b1007c67","dropdown":"82bf0124","mobilePopup":"93a8f3c3","selectPopup":"2045e91d","search":"a334f311","userModule":"c0cebdd9","chunk-4673eeb4":"2663181a","chunk-327e7090":"5d843608","notification":"c8ace9f0","popupResetPassword":"2e03753c","popupSignup":"90c03538","profileMenu":"d836045d","chunk-2d21ecf9":"31d6cfe0","logoutIconVlite":"2a47b66a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
